<template>
  <section class="cat-header">
    <div class="container-fluid">
      <div
        class="row align-items-center"
        style="max-width: 1200px; margin: 0 auto"
      >
        <div class="col-sm-5 award-logo">
          <a v-if="item.categoryIntro" href="../">
            <img src="@/assets/img/header-award-logo.svg" alt="" />
          </a>
          <a v-else href="../">
            <img class="no-intro-award-logo" src="@/assets/img/header-award-logo.svg" alt="" />
          </a>
        </div>
        <div class="col-sm-7">
          <div class="row align-items-center">
            <div class="col-sm-4 cat-header__award-illustration">
              <img src="@/assets/img/award-logo-illustration.svg" alt="" />
            </div>
            <div class="col-sm-8 cat-header__award-title resize-to-fit-80">
              <h2 :style="categoryNameStyle" ref="categoryName">
                {{ item.categoryName }}
              </h2>
            </div>
          </div>

          <div class="cat-header__introduction">
            <p v-html="item.categoryIntro"></p>
          </div>
        </div>
      </div>

      <div class="marquee pc-only">
        <div class="marquee__inner" aria-hidden="true">
          <span>
            MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
            MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
            MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
            AWARDS MAGMAG AWARDS MAGMAG AWARDS
          </span>
        </div>
      </div>
      <div>
        <a href="#1">
          <img
            style="height: 20px; margin: 5px 0"
            class="sp-only"
            src="@/assets/img/down-triangle-pointer.svg"
            alt=""
          />
        </a>
      </div>

      <div class="marquee-sp sp-only">
        <div class="marquee">
          <div class="marquee__inner" aria-hidden="true">
            <span>
              MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
              AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
              MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
              AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
              MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG
              AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS MAGMAG AWARDS
              MAGMAG AWARDS
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      categoryNameFontSize: 80
    }
  },
  computed: {
    categoryNameStyle() {
      return {
        'font-size': `${this.categoryNameFontSize}px`
      }
    }
  },
  mounted() {
    this.fitCategoryNameFont()
  },
  methods: {
    fitCategoryNameFont() {
      if (this.$refs.categoryName.clientHeight >= 80) {
        this.categoryNameFontSize -= 1
        this.$nextTick(() => {
          this.fitCategoryNameFont()
        })
      }
    }
  }
}
</script>

<style scoped>
.award-logo {
  text-align: center;
}
/* header */
.cat-header {
  /* max-width: 1200px; */
  font-family: 游明朝, 'Yu Mincho', YuMincho, 'Hiragino Mincho ProN',
    'Hiragino Mincho Pro', HGS明朝E, メイリオ, Meiryo, serif;
  margin: 40px auto;
}
.cat-header img {
  width: 100%;
  margin-bottom: 10px;
}
.cat-header__award-title {
  text-align: center;
  border-style: solid none solid none;
  border-width: 0.5px;
  border-color: #222;
  position: relative;
  height: 80px;
}

.cat-header__award-title h2 {
  font-size: min(8vw, 80px);
  width: fit-content;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 800;
}

.cat-header__introduction {
  margin-top: 10px;
}
.cat-header__introduction p{
  word-break: normal;
}
@media screen and (min-width: 500px) {
  .award-logo {
    margin-bottom: 40px;
    /* max-width: 400px; */
  }
}

@media screen and (max-width: 500px) {
  .cat-header {
    position: absolute;
    top: 47%;
    transform: translateY(-50%);
  }

  .award-logo img {
    width: 60% !important;
  }

  img.no-intro-award-logo {
    width: 80% !important;
    margin-bottom: 20px;
  }
}

@media screen and (max-height: 600px) {
  .marquee-sp {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .cat-header__award-title {
    border-style: solid none solid none;
    height: 80px;
  }

  .cat-header__award-illustration {
    width: 70%;
    margin: 5px auto;
  }

  .cat-header__award-illustration img {
    height: 20vh;
  }
}

/* marquee css */
.marquee {
  position: relative;
  overflow: hidden;
  --offset: 20vw;
  --move-initial: calc(-35% + var(--offset));
  --move-final: calc(-45% + var(--offset));

  background: #222;
  color: #d4af37;
  width: 99vw;
  margin: 0 -15px;
  height: 60px;
}
@media all and (-ms-high-contrast: none) {
  .marquee {
    display: none;
  }
}
.marquee__inner {
  width: fit-content;
  display: flex;
  position: relative;
  transform: translate3d(var(--move-initial), 0, 0);
  animation: marquee 5s linear infinite;
  animation-play-state: running;

  width: 5000px;
  height: 50px;
}

.marquee span {
  font-size: 24px;
  /* padding: 0 2vw; */
  margin-top: 10px;
  border: solid 0.5px #d4af37;
}

.marquee-sp {
  /* position: absolute;
  bottom: -10px; */
}

@keyframes marquee {
  0% {
    transform: translate3d(var(--move-initial), 0, 0);
  }

  100% {
    transform: translate3d(var(--move-final), 0, 0);
  }
}
</style>
